<div class="loader" *ngIf="show | async">
    <div class="loader-box">
        <span class="spinner"><span class="calota"></span></span>
        <span class="loading">
            {{ message | async }}
        </span>
    </div>
</div>